module.exports = __webpack_public_path__ + "static/media/pic6.9e227f89.jpg";